import { useState } from "react";
import { faqs } from "@/mocks/faq";
import JsonLd from "@/components/feature/JsonLd";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6" aria-labelledby="faq-heading">
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <div className="mx-auto max-w-3xl text-center">
        <span className="text-sm font-medium text-accent-600">FAQ</span>
        <h2 id="faq-heading" className="mt-1 font-heading text-2xl text-foreground-900 md:text-3xl">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-600">关于漫画分类大全、排行榜与推荐的常见疑问。</p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl">
        {faqs.map((f, idx) => {
          const open = openIdx === idx;
          return (
            <div
              key={f.q}
              className="mb-3 overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
            >
              <button
                type="button"
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                onClick={() => setOpenIdx(open ? -1 : idx)}
                aria-expanded={open}
              >
                <h3 className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</h3>
                <i
                  className={`shrink-0 text-lg text-primary-500 transition-transform ${
                    open ? "ri-subtract-line" : "ri-add-line"
                  }`}
                />
              </button>
              {open && (
                <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}